import { MenuItem as ChakraMenuItem, MenuItemProps } from '@chakra-ui/react';
export {
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  useMenu,
  useMenuButton,
  useMenuContext
} from '@chakra-ui/react';
export type {
  MenuButtonProps,
  MenuDividerProps,
  MenuGroupProps,
  MenuItemOptionProps,
  MenuItemProps,
  MenuListProps,
  MenuOptionGroupProps,
  MenuProps
} from '@chakra-ui/react';

export function MenuItem(props: MenuItemProps): JSX.Element {
  return (
    <ChakraMenuItem
      py="space_unit.x1"
      _hover={{
        color: 'palette_blue.100',
        backgroundColor: 'palette_blue.5'
      }}
      _focus={{
        color: 'palette_blue.100',
        backgroundColor: 'palette_blue.5'
      }}
      {...props}
    />
  );
}
